/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'de-center': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M15 29c7.732 0 14-6.268 14-14S22.732 1 15 1 1 7.268 1 15s6.268 14 14 14zm0 1c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z" _fill="#6D9AE8"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M20 8h-5v13h5V8zm-6-1v15h7V7h-7z" _fill="#6D9AE8"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M18 10h-1v1h1v-1zm-2-1v3h3V9h-3zM18 17h-1v1h1v-1zm-2-1v3h3v-3h-3zM16 13v2h3v-2h-3zM10 17v3h2v-3h-2z" _fill="#6D9AE8"/><path pid="3" fill-rule="evenodd" clip-rule="evenodd" d="M14 16H9v5h5v-5zm-6-1v7h7v-7H8z" _fill="#6D9AE8"/>'
  }
})
